import { useEffect, useMemo, useState } from 'react';

function useIsTyping(text: string, delay?: number): boolean {
  const [debouncedText, setDebouncedValue] = useState(text);

  const isTyping = useMemo(() => text !== '' && debouncedText !== text, [text, debouncedText]);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(text), delay || 2000);

    return () => {
      clearTimeout(timer);
    };
  }, [text, delay]);

  return isTyping;
}

export default useIsTyping;
